import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { EscalationMailFormArray } from './escalation-mail-form-array';

export class EmailControl extends FormControl {
    private static readonly duplicateEmailError = 'duplicateEmail';
    public value: string;
  
    constructor(
      private readonly mail: string,
      private readonly mailFormArray: EscalationMailFormArray
    ) {
      super(mail, [Validators.required,
      Validators.pattern(/^[\w.-]*@[\w.-]*\.\w+$/),
      EmailControl.duplidateEmailValidator(mailFormArray)]);
    }
  
    public get hasDuplidateEmailError(): boolean {
      return this.hasError(EmailControl.duplicateEmailError);
    }
    
    private static duplidateEmailValidator(mailFormArray: EscalationMailFormArray): ValidatorFn {
      return (currentControl: EmailControl) => {
        const invalidResult = { [this.duplicateEmailError]: true };
  
        for (let emailControl of mailFormArray.emailFormControls) {
          if (currentControl === emailControl) {
            continue;
          }
  
          if ((emailControl.value || '').trim() === currentControl.value) {
            return invalidResult;
          }
        }
  
        return null;
      };
    }
  }